import { CharlieSeparator, CharlieSkeleton } from '@ver.id/libs.ui.charlie';

/** Skeleton loading state for the sidebar — matches Figma node 64:7730 */
export default function HostedSidebarSkeleton() {
  return (
    <div className="flex flex-col gap-9 w-full h-full pt-10">
      {/* Logo skeleton */}
      <div className="flex items-center gap-4">
        <CharlieSkeleton className="size-10 rounded-full" />
        <div className="flex flex-col gap-2">
          <CharlieSkeleton className="h-4 w-40" />
          <CharlieSkeleton className="h-4 w-24" />
        </div>
      </div>

      {/* Title + description skeleton */}
      <div className="flex flex-col gap-4">
        <CharlieSkeleton className="h-8 w-72" />
        <div className="flex flex-col gap-2">
          <CharlieSkeleton className="h-4 w-full" />
          <CharlieSkeleton className="h-4 w-full" />
        </div>
      </div>

      <CharlieSeparator />

      {/* Steps skeleton */}
      <div className="flex flex-1 flex-col gap-9">
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-2">
            <CharlieSkeleton className="h-4 w-40" />
          </div>
          <CharlieSkeleton className="h-[65px] w-full rounded-md" />
        </div>

        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-2">
            <CharlieSkeleton className="h-4 w-40" />
          </div>
          <CharlieSkeleton className="h-[207px] w-full rounded-md" />
        </div>
      </div>

      {/* Terms skeleton */}
      <div className="flex flex-col gap-4 pb-10">
        <CharlieSkeleton className="h-5 w-40" />
        <div className="flex flex-col gap-2">
          <CharlieSkeleton className="h-4 w-full" />
          <CharlieSkeleton className="h-4 w-full" />
        </div>
      </div>
    </div>
  );
}
